import huntingPizzaCoverImage from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaCoverImage.webp";
import huntingPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaCoverImageMobile.webp";
import huntingPizzaAboutImage from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaAboutImage.webp";
import margarittaPizzaCoverImage from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaCoverImage.webp";
import margarittaPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaCoverImageMobile.webp";
import margarittaPizzaAboutImage from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaAboutImage.webp";
import havaianPizzaCoverImage from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaCoverImage.webp";
import havaianPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaCoverImageMobile.webp";
import havaianPizzaAboutImage from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaAboutImage.webp";
import trianglesCoverImage from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesCoverImage.webp";
import trianglesCoverImageMobile from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesCoverImageMobile.webp";
import trianglesAboutImage from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesAboutImage.webp";
import batonCoverImage from "../../assets/images/AllReciptsImages/BatonImages/batonCoverImage.webp";
import batonCoverImageMobile from "../../assets/images/AllReciptsImages/BatonImages/batonCoverImageMobile.webp";
import batonAboutImage from "../../assets/images/AllReciptsImages/BatonImages/batonAboutImage.webp";
import cheeseMuffinsCoverImage from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsCoverImage.webp";
import cheeseMuffinsCoverImageMobile from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsCoverImageMobile.webp";
import cheeseMuffinsAboutImage from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsAboutImage.webp";

export const RecipesPagesArr = [
  {
    path: "/recipes/hunting-pizza",
    metaTitle: "Піца Мисливська",
    metaDescription: "Піца Мисливська — це смачна страва з хрустким коржем, щедро змащеним томатним соусом і оливки",
    coverImage: huntingPizzaCoverImage,
    coverImageMobile: huntingPizzaCoverImageMobile,
    coverTitle: "Піца Мисливська",
    aboutText: "Піца Мисливська — це смачна страва з хрустким коржем, щедро змащеним томатним соусом і оливки. Її начинка включає ароматну мисливську ковбасу, мариновані огірки та ріпчасту цибулю, які надають піці насиченого смаку. Завдяки вдалому поєднанню інгредієнтів, ця піца стане ідеальним вибором для справжніх шанувальників м'ясних делікатесів.",
    aboutImage: huntingPizzaAboutImage,
    ingredients: [
      {
        title: "Сир Український Pastoral",
        amount: "250 г.",
      },
      {
        title: "Борошно",
        amount: "400 г.",
      },
      {
        title: "Вода",
        amount: "250 мл.",
      },
      {
        title: "Оливкова олія",
        amount: "2 ст. л.",
      },
      {
        title: "Цукор, сіль, дріжджі",
        amount: "2 ч. л.",
      },
      {
        title: "Томатний соус",
        amount: "4 ст. л.",
      },
      {
        title: "Ковбаса мисливська",
        amount: "150 г.",
      },
      {
        title: "Оливки",
        amount: "50 г.",
      },
      {
        title: "Цибуля ріпчаста",
        amount: "1 шт.",
      },
      {
        title: "Мариновані огірки",
        amount: "3 шт.",
      },
    ],
    steps: [
        "У теплій воді розчиніть цукор і додайте дріжджі, залиште суміш на 10 хвилин для активації. Після того, як дріжджі почнуть діяти, додайте сіль, оливкову олію і просіяне борошно.",
        "Ретельно вимісіть тісто до гладкої, м'якої консистенції, щоб воно стало еластичним під руками.",
        "Після цього накрийте миску чистим рушником і помістіть тісто в тепле місце на 1–1,5 години, щоб воно підійшло та збільшилося вдвічі.",
        "Після того, як тісто підніметься, акуратно обімніть його, видаляючи зайве повітря, та розкачайте у рівний круглий пласт товщиною приблизно 5–7 мм.",
        "Рівномірно розподіліть по поверхні тіста томатний соус, залишивши невеликі краї незайманими.",
        "Розкладіть скибочки мисливської ковбаси, маринованих огірків, цибулю та оливки. Посипте тертим сиром Український Pastoral.",
        "Розігрійте духовку до температури 220–250°C. Випікайте піцу протягом 10–12 хвилин, поки основа не набуде апетитного золотистого кольору, а сир не розплавиться й не підрум'яниться.",
    ]
  },
  {
    path: "/recipes/margaritta-pizza",
    metaTitle: "Піца Маргарита",
    metaDescription: "Піца Маргарита — це легендарна страва італійської кухні, основою якої є тонке тісто, покрите ароматним томатним соусом",
    coverImage: margarittaPizzaCoverImage,
    coverImageMobile: margarittaPizzaCoverImageMobile,
    coverTitle: "Піца Маргарита",
    aboutText: "Піца Маргарита — це легендарна страва італійської кухні, основою якої є тонке тісто, покрите ароматним томатним соусом, ніжною моцарелою та свіжими листочками базиліку. Її смакова гармонія поєднує соковитість стиглих помідорів, вершкову текстуру сиру та яскравий аромат зелені. Простота та вишуканість Маргарити роблять її справжнім символом автентичної італійської кулінарної традиції.",
    aboutImage: margarittaPizzaAboutImage,
   ingredients: [
      {
        title: "Сир Карпатьський Pastoral",
        amount: "250 г.",
      },
      {
        title: "Моцарела Pastoral",
        amount: "50 г.",
      },
      {
        title: "Борошно",
        amount: "400 г.",
      },
      {
        title: "Вода",
        amount: "250 мл.",
      },
      {
        title: "Оливкова олія",
        amount: "2 ст. л.",
      },
      {
        title: "Цукор, сіль, дріжджі",
        amount: "2 ч. л.",
      },
      {
        title: "Томатний соус ",
        amount: "4 ст. л.",
      },
      {
        title: "Сметанний соус",
        amount: "2 ст. л.",
      },
      {
        title: "Томати",
        amount: "2 шт.",
      },
    ],
    steps: [
        "У теплій воді розчиніть цукор і додайте дріжджі, залиште суміш на 10 хвилин для активації. Після того, як дріжджі почнуть діяти, додайте сіль, оливкову олію і просіяне борошно.",
        "Ретельно вимісіть тісто до гладкої, м'якої консистенції, щоб воно стало еластичним під руками.",
        "Після цього накрийте миску чистим рушником і помістіть тісто в тепле місце на 1–1,5 години, щоб воно підійшло та збільшилося вдвічі.",
        "Після того, як тісто підніметься, акуратно обімніть його, видаляючи зайве повітря, та розкачайте у рівний круглий пласт товщиною приблизно 5–7 мм.",
        "Рівномірно розподіліть по поверхні тіста томатний і сметанний соуси, залишивши невеликі краї незайманими.",
        "Викладіть зверху скибочки моцарели Pastoral, посипте натертим сиром Карпатьський Pastoral та збризніть оливковою олією для додаткового аромату й ніжності.",
        "Розігрійте духовку до температури 220–250°C. Випікайте піцу протягом 10–12 хвилин, поки основа не набуде апетитного золотистого кольору, а сир не розплавиться й не підрум'яниться.",
    ]
  },
  {
    path: "/recipes/havaian-pizza",
    metaTitle: "Піца Гавайська",
    metaDescription: "Гавайська піца — це неповторне поєднання італійської класики з екзотичним тропічним акцентом.",
    coverImage: havaianPizzaCoverImage,
    coverImageMobile: havaianPizzaCoverImageMobile,
    coverTitle: "Піца Гавайська",
    aboutText: "Гавайська піца — це неповторне поєднання італійської класики з екзотичним тропічним акцентом. Її основу становить тонке тісто, покрите соковитим томатним соусом і особливим акцентом на солодких ананасах та ніжній шинці. Завдяки гармонії солодких і солоних смаків, ця піца вирізняється своєю унікальністю серед інших кулінарних шедеврів.",
    aboutImage: havaianPizzaAboutImage,
    ingredients: [
      {
        title: "Сир Звенигородський Pastoral",
        amount: "250 г.",
      },
      {
        title: "Борошно",
        amount: "400 г.",
      },
      {
        title: "Вода",
        amount: "250 мл.",
      },
      {
        title: "Оливкова олія",
        amount: "2 ст. л.",
      },
      {
        title: "Цукор, сіль, дріжджі",
        amount: "2 ч. л.",
      },
      {
        title: "Томатний соус",
        amount: "4 ст. л.",
      },
      {
        title: "Шинка",
        amount: "150 г.",
      },
      {
        title: "Консервовані ананаси",
        amount: "150 г.",
      },
    ],
    steps: [
        "У теплій воді розчиніть цукор і додайте дріжджі, залиште суміш на 10 хвилин для активації. Після того, як дріжджі почнуть діяти, додайте сіль, оливкову олію і просіяне борошно.",
        "Ретельно вимісіть тісто до гладкої, м'якої консистенції, щоб воно стало еластичним під руками.",
        "Після цього накрийте миску чистим рушником і помістіть тісто в тепле місце на 1–1,5 години, щоб воно підійшло та збільшилося вдвічі.",
        "Після того, як тісто підніметься, акуратно обімніть його, видаляючи зайве повітря, та розкачайте у рівний круглий пласт товщиною приблизно 5–7 мм.",
        "Рівномірно розподіліть по поверхні тіста томатний соус, залишивши невеликі краї незайманими. Викладіть шматочки шинки та ананаси. Посипте тертим сиром Звенигородський Pastoral.",
        "Розігрійте духовку до температури 220–250°C. Випікайте піцу протягом 10–12 хвилин, поки основа не набуде апетитного золотистого кольору, а сир не розплавиться й не підрум'яниться.",
    ]
  },
  {
    path: "/recipes/triangles",
    metaTitle: "Трикутники",
    metaDescription: "Трикутники — це апетитні хрусткі пиріжки з ніжною, соковитою начинкою, яка прихована всередині",
    coverImage: trianglesCoverImage,
    coverImageMobile: trianglesCoverImageMobile,
    coverTitle: "Трикутники",
    aboutText: "Трикутники — це апетитні хрусткі пиріжки з ніжною, соковитою начинкою, яка прихована всередині тонкого тіста. Гармонія розтопленого твердого сиру та ароматного м'яса створює вибух смаків, а хрустка золотиста скоринка надає страві особливої текстури. Ідеальні як для швидкого перекусу, так і для вишуканої подачі, трикутники додають вашому столу елегантності та кулінарної різноманітності.",
    aboutImage: trianglesAboutImage,
    ingredients: [
      {
        title: "Масло Екстра 73% Pastoral",
        amount: "200 г.",
      },
      {
        title: "Сир Український Pastoral",
        amount: "250 г.",
      },
      {
        title: "Борошно",
        amount: "600 г.",
      },
      {
        title: "Вода",
        amount: "300 мл.",
      },
      {
        title: "Оцет",
        amount: "10 г.",
      },
      {
        title: "Яйця",
        amount: "1 шт.",
      },
      {
        title: "Сіль",
        amount: "5 г.",
      },
      {
        title: "Готове м’ясо",
        amount: "200 г.",
      },
    ],
    steps: [
        "Змішайте просіяне борошно з водою та яйцями, ретельно розмішуючи до отримання однорідної маси.",
        "Додайте Масло солодковершкове Екстра 73% Pastoral, дрібку солі та краплю оцту, після чого замісіть тісто вручну до еластичності.",
        "Розкачайте тісто в пласт товщиною близько 5 мм, розріжте його на великі квадрати або прямокутники, а потім наповніть шматочками готового м'яса та Сир Український Pastoral.",
        "Закрийте краї кожного квадрата, зліпивши трикутники, і перекладіть на деко. Випікайте в духовці, розігрітій до 180-200°C, протягом 25-30 хвилин до золотистої скоринки.",
    ]
  },
  {
    path: "/recipes/baton",
    metaTitle: "Батон",
    metaDescription: "Батон — це апетитний хліб довгастої форми з ніжним, пухким м'якушем і хрусткою, золотистою скоринкою",
    coverImage: batonCoverImage,
    coverImageMobile: batonCoverImageMobile,
    coverTitle: "Батон",
    aboutText: "Батон — це апетитний хліб довгастої форми з ніжним, пухким м'якушем і хрусткою, золотистою скоринкою. Його запашний аромат під час випікання наповнює оселю затишком, а смак ідеально підходить як для простих перекусів зі свіжим маслом, так і для створення складних бутербродів. Завдяки своїй універсальності та легкості у приготуванні, батон залишається незамінним у щоденному раціоні.",
    aboutImage: batonAboutImage,
    ingredients: [
      {
        title: "Топлене масло ГХІ Pastoral",
        amount: "2 ст. л.",
      },
      {
        title: "Борошно",
        amount: "1 кг.",
      },
      {
        title: "Вода",
        amount: "650 мл.",
      },
      {
        title: "Дріжджі",
        amount: "7 г.",
      },
      {
        title: "Цукор",
        amount: "1 ст. л.",
      },
      {
        title: "Сіль",
        amount: "1.5 ч. л.",
      },

    ],
    steps: [
        "У теплу воду додайте цукор і дріжджі, перемішайте та залиште на 10 хвилин, поки зверху не з’явиться піниста 'шапочка'.",
        "У великій мисці просійте борошно, додайте сіль, влийте активовані дріжджі та топлене масло ГХІ Pastoral. Почніть замішувати тісто ложкою, а потім руками, щоб воно почало формуватися.",
        "Вимішуйте тісто протягом 7–10 хвилин, доки воно не стане м’яким та еластичним під руками.",
        "Сформуйте з тіста кулю, помістіть її в змащену олією миску та накрийте рушником або плівкою. Залиште в теплі на 1–1,5 години, щоб тісто піднялося і збільшилося в об’ємі вдвічі.",
        "Після підйому обімніть тісто, надайте йому довгасту форму батона і викладіть на пергаментний лист. Залиште батон для другого підйому на 30–40 хвилин під рушником.",
        "Зробіть на батоні кілька діагональних надрізів, розігрійте духовку до 200–220°C і випікайте близько 25–30 хвилин, доки скоринка не стане золотистою.",
    ]
  },
  {
    path: "/recipes/Cheese-muffins",
    metaTitle: "Сирні кекси",
    metaDescription: "Сирні кекси — це легкі й ніжні десерти, які буквально розчиняються на язиці",
    coverImage: cheeseMuffinsCoverImage,
    coverImageMobile: cheeseMuffinsCoverImageMobile,
    coverTitle: "Сирні кекси",
    aboutText: "Сирні кекси — це легкі й ніжні десерти, які буквально розчиняються на язиці завдяки своїй пухкій, повітряній структурі. Їхній делікатний солодкий смак із тонким відтінком ванілі чудово поєднується з ароматом свіжоспеченого тіста. Ідеальні як для ранкової чашки кави, так і для смачної перерви протягом дня, ці кекси додадуть затишку будь-якій трапезі.",
    aboutImage: cheeseMuffinsAboutImage,
    ingredients: [
      {
        title: "Масло Екстра 72,5% Pastoral",
        amount: "200 г",
      },
      {
        title: "Сир кисломолочний 9% Pastoral",
        amount: "200 г",
      },
      {
        title: "Цукор",
        amount: "150 г.",
      },
      {
        title: "Родзинки",
        amount: "100 г.",
      },
      {
        title: "Ваніль",
        amount: "10 г",
      },
      {
        title: "Яйця",
        amount: "3 шт.",
      },
      {
        title: "Сіль",
        amount: "10 г.",
      },
    ],
    steps: [
        "Збийте Сир кисломолочний 9% Pastoral із яйцями до однорідної, гладкої консистенції. Додайте цукор, ваніль та дрібку солі, ретельно перемішайте всі інгредієнти.",
        "Додайте Масло солодковершкове Екстра 72,5% Pastoral й знову добре перемішайте масу до однорідності. Розлийте тісто у форми для кексів, додавши родзинки або іншу начинку на ваш вибір.",
        "Розлийте тісто у форми для кексів, додавши родзинки або іншу начинку на ваш вибір.",
        "Випікайте у попередньо розігрітій духовці при температурі 180-200°C протягом 35-40 хвилин, перевіряючи готовність зубочисткою — якщо вона виходить чистою, кекси готові.",
    ]
  },
];


